<div id="loginOverlay" [class.light-theme-bg]="!colorService.isDarkTheme">
  <div id="container">
    <div class="rounded-visible-container">
      <img id="logo" [src]='colorService.isDarkTheme ? "assets/godh_logo_inverted_transparency.png" : "assets/godh_logo_transparency.png"'>
      <div id="separator-container">
        <div id="separator"></div>
      </div>
      <div class="fluid-ui-replacer loginOverlayContainer" style="padding-left: 20px; padding-right: 10px">
        <div class="flex flex-column justify-content-between h-full pb-2">
          <h2 class="col-12 p-nogutter" style="margin-top: 50px">Welcome</h2>
          <div *ngIf="noOrganizations">
            <p style="margin-top: 20px">You are not part of any organizations.</p>
            <p style="margin-top: 20px">Get setup fast.</p>
            <a class="font-medium no-underline ml-2 text-yellow-600 cursor-pointer" (click)="displayCreateOrganizationDialogEvent.emit()">Create organization</a>
          </div>
          <div class="organizations-container" *ngIf="!noOrganizations">
            <div *ngFor="let organization of tenants" class="organization-entry" (click)="connectToOrganization(organization)">
              <div class="organization-code clamp-one-row">{{organization.tenant.tenantName}}</div>
              <div class="organization-description clamp-one-row">{{organization.tenant.tenantDescription}}</div>
            </div>
          </div>
          <button (click)="logout()">Logout <i class="fas fa-sign-out"></i></button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-create-organization-form [openModal]="displayCreateOrganizationDialogEvent" (success)="refreshTenants()"></app-create-organization-form>
